export default __webpack_public_path__ + "static/media/BOTAO-GEOCONTROLE.62d5d25f.jfif";